<template>
    <div>
        <b-modal :no-enforce-focus="true" id="modal-change-password"
                 ref="modal"
                 no-close-on-backdrop
                 :title="title"
                 @show="resetModal"
                 @hidden="resetModal"
                 @ok="handleOk">
            <form ref="form" @submit.stop.prevent="submit">
                <!--<b-form-group :state="nameState"
                              label="Name"
                              label-for="name-input"
                              invalid-feedback="Name is required">
                    <b-form-input id="name-input"
                                  v-model="name"
                                  :state="nameState"
                                  required></b-form-input>
                </b-form-group>-->
                <b-form-group label="Mật khẩu cũ:"
                              label-for="newPassword"
                              label-cols-md="4"
                              label-align="left"
                              :horizontal="true"
                              label-class="required">
                    <b-form-input type="password" id="oldPassword"
                                  v-model="$v.user.oldPassword.$model"
                                  @input="$v.user.oldPassword.$touch"
                                  :state="$v.user.oldPassword.$dirty? !$v.user.oldPassword.$error : null">
                    </b-form-input>
                    <b-form-invalid-feedback v-if="!$v.user.oldPassword.required">
                        Mật khẩu không được để trống!
                    </b-form-invalid-feedback>
                    <!--<b-form-invalid-feedback v-if="!$v.user.oldPassword.minLength">
                        Mật khẩu phải có ít nhất 8 ký tự
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="$v.user.oldPassword.minLength && !$v.user.oldPassword.passwordPattern">
                        Mật khẩu phải chứa chữ hoa, chữ thường, số và ký tự đặc biệt
                    </b-form-invalid-feedback>-->
                </b-form-group>
                <b-form-group label="Mật khẩu mới:"
                              label-for="newPassword"
                              label-cols-md="4"
                              label-align="left"
                              :horizontal="true"
                              label-class="required">
                    <b-form-input type="password" id="newPassword"
                                  v-model="$v.user.newPassword.$model"
                                  @input="$v.user.newPassword.$touch"
                                  :state="$v.user.newPassword.$dirty? !$v.user.newPassword.$error : null">
                    </b-form-input>
                    <b-form-invalid-feedback v-if="!$v.user.newPassword.required">
                        Mật khẩu mới không được để trống !
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.user.newPassword.minLength">
                        Mật khẩu phải có ít nhất 8 ký tự
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="$v.user.newPassword.minLength && !$v.user.newPassword.passwordPattern">
                        Mật khẩu phải chứa chữ hoa, chữ thường, số và ký tự đặc biệt
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.user.newPassword.notContainUsername">
                        Mật khẩu không được chứa tên đăng nhập
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Nhập lại mật khẩu mới:"
                              label-for="newPasswordConfirm"
                              label-cols-md="4"
                              label-align="left"
                              :horizontal="true"
                              label-class="required">
                    <b-form-input type="password" id="newPasswordConfirm"
                                  v-model="$v.user.newPasswordConfirm.$model"
                                  @input="$v.user.newPasswordConfirm.$touch"
                                  :state="$v.user.newPasswordConfirm.$dirty? !$v.user.newPasswordConfirm.$error : null">
                    </b-form-input>
                    <b-form-invalid-feedback v-if="!$v.user.newPasswordConfirm.required">
                        Mật khẩu mới không được để trống !
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.user.newPasswordConfirm.sameAsPassword">
                        Mật khẩu không khớp
                    </b-form-invalid-feedback>
                </b-form-group>
            </form>
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button type="button" variant="primary" @click="ok()">
                    Lưu
                </b-button>
                <b-button type="button" variant="secondary" @click="cancel()">
                    Hủy
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    import store from '@/store/index'
    const passwordPattern = helpers.regex('passwordPattern', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/)
    const notContainUsername = (value) => value == null || !value.toLowerCase().includes(store.state.identity.username.toLowerCase())

    export default {
        data() {
            return {
                user: {
                    oldPassword: null,
                    newPassword: null,
                    newPasswordConfirm: null,
                },
                title: "Đổi mật khẩu"
            }
        },
        validations: {
            user: {
                oldPassword: { required, /*minLength: minLength(8), passwordPattern*/ },
                newPassword: { required, minLength: minLength(8), passwordPattern, notContainUsername },
                newPasswordConfirm: { required, sameAsPassword: sameAs('newPassword') },
            }
        },
        mounted() {
            var vm = this;
            this.$services.get('users/password-status').done((status) => {
                if (status.isFirstTimeLogin) {
                    vm.title = "Đổi mật khẩu cho lần đăng nhập đầu tiên";
                    vm.$refs.modal.show();
                } else if (status.passwordExpireNotification) {
                    if (status.passwordExpireDay > 0) {
                        vm.$toastr.w(`Mật khẩu sẽ hết hạn trong ${status.passwordExpireDay} ngày tới. Vui lòng đổi mật khẩu ngay.`);
                    } else {
                        vm.$toastr.w(`Mật khẩu đã hết hạn. Vui lòng đổi mật khẩu ngay.`);
                    }
                }
            });
        },
        methods: {
            resetModal() {
                this.user.oldPassword = null;
                this.user.newPassword = null;
                this.user.newPasswordConfirm = null;
                this.$v.$reset();
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault()
                this.submit();
            },
            cancel(bvModalEvt) {
                this.$bvModal.hide('modal-change-password');
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.put(`users/password`, this.user).done(() => {
                        vm.cancel();
                        vm.$toastr.s('Thay đổi mật khẩu thành công');

                        vm.title = 'Đổi mật khẩu';
                    });
                }
            }
        }
    }
</script>